//金额验证
// function checkEquipment(){
//     const {userAgent} = navigator
//     if(userAgent.match(/(Win32 | Win16 | Win64| WinCE | MacIntel|Mac68K | MacPPC | Linux mips64)/i)){
//       console.log('电脑')
//       console.log('window.location.pathname',window.location.pathname)
//       if(document.domain=='m.ellassay.com'){
//         window.location.href=`https://www.ellassay.com${this.$route.path}`
//       }
      
//     }
//     if(userAgent.match(/(iPhone | Android | SymbianOS| Windows Phone  | iPod|iPad | Linux armv8l | Linux)/i)){
//       console.log('手机') 
//       if(document.domain=='www.ellassay.com'){
//          window.location.href=`https://m.ellassay.com${this.$route.path}`
//       }
//     }
//   }

function checkEquipmentFn(){
    let url=window.location.href
    console.log('urllllllll',url)
    const urlObject = new URL(url);
        // 从URL对象获取路径
    const path = urlObject.pathname + urlObject.search;
    console.log('想要的地址',path); // 输出："/groupint?id=1"

        const {userAgent} = navigator
    if(userAgent.match(/(Win32 | Win16 | Win64| WinCE | MacIntel|Mac68K | MacPPC | Linux mips64)/i)){
      console.log('电脑')
      
      if(document.domain=='m.ellassay.com'){
        window.location.href=`https://www.ellassay.com${path}`
      }
    }
    if(userAgent.match(/(iPhone | Android | SymbianOS| Windows Phone  | iPod|iPad | Linux armv8l | Linux)/i)){
      console.log('手机---') 
      if(document.domain=='www.ellassay.com'){
        window.location.href=`https://m.ellassay.com${path}`
      }
    }
  }

export {
	checkEquipmentFn
}


// WEBPACK FOOTER //
// ./src/common/common.js